import { photo } from './photo';
import { tag } from './tag';
import { myroom } from './myroom';

export type auth0contactError = {
    error: string;
    id: string;
    mail: string;
    verifiedMail: boolean;
}

export type contact = {
    _id: string;
    name: string;
    surname: string;
    cardNumber: string;
    email: string;
    tel: string;
    photo?: photo;
    tags?: Array<tag>;
    sub: string;
    connectionId: string;
    pictureUri?: string;
    birthDate?: Date;
    lastLogin?: Date;
    blockAccessOn?: Date;
    greenPass?: greenPass;
    rooms?: Array<myroom>;
}

export const emptyContact = () => ({
    _id: '',
    email: '',
    name: '',
    surname: '',
    tel: '',
    photo: undefined,
    tags: [],
    sub: '',
    connectionId: '',
    rooms: [],
    cardNumber: ''
})

export type greenPass = {
    expiresOn?: Date;
    greenPassTimestamp?: Date;
}

export type contactPaginationResponse = {
    contacts: Array<contact>;
    totalRows: number;
}

export type createContact = {
    name: string;
    surname: string;
    email: string;
    tel: string;
    password: string;
    confirmPassword: string;
}


export const emptyCreateContact = (): createContact => ({
    name: ``,
    surname: ``,
    email: ``,
    tel: ``,
    password: ``,
    confirmPassword: ``,
})